import React, { ReactElement } from 'react';
import FormatService from '../../services/format-service';
import useStylesImageFileContainer from './image-file-container.styles';

const ImageFileContainer: ReactMemoComponent = React.memo((props: ReactComponentProps): ReactElement => {
  const {
    withSubBlock,
    withNoOffset,
    withLargeImage,
    className,
    children,
  } = props;

  const { classes } = useStylesImageFileContainer();

  const withSubBlockClassName: string | undefined = withSubBlock ? classes.imageFileContainerWithSubBlock : undefined;
  const largeImageClassName: string | undefined = withLargeImage ? classes.imageFileContainerLargeImage : undefined;
  const noOffsetClassName: string | undefined = withNoOffset ? classes.imageFileContainerNoOffset : undefined;

  return (
    <div
      className={FormatService.formatClassNames(
        classes.imageFileContainer, withSubBlockClassName, largeImageClassName, noOffsetClassName, className,
      )}
    >
      {children}
    </div>
  );
});

export default ImageFileContainer;
